import type {
  RentalManagerListingRestrictionsDto,
  RentalManagerUserPropertyDetailsApplicationsRestrictionDto,
} from '@zg-rentals/rental-manager-env';

const Applications = ({
  isAccessRestricted = false,
  isUpdateRestricted = false,
  ownerEmail = '',
}: Partial<RentalManagerUserPropertyDetailsApplicationsRestrictionDto>): RentalManagerUserPropertyDetailsApplicationsRestrictionDto => ({
  isAccessRestricted: Boolean(isAccessRestricted),
  isUpdateRestricted: Boolean(isUpdateRestricted),
  ownerEmail: String(ownerEmail),
});

const CurrentPropertyRestrictions = ({
  applications = {},
  isAnalyticsRestricted = false,
  isCloneListingRestricted = false,
  isLeaseBuilderRestricted = false,
  isLeasesRestricted = false,
  isMessagesRestricted = false,
  isPaymentsRestricted = false,
  isPropertyAmenitiesUpdateRestricted = false,
  isReviewsRestricted = false,
  isUpdateAgentRestricted = false,
  isUpdateListingRestricted = false,
  isUpdateSpecialOffersRestricted = false,
  isUpdateUnitNumberRestricted = false,
  isUpdateUnitRestricted = false, // deprecate once `isPartialListingManaged` is ready via BE
}: Partial<Omit<RentalManagerListingRestrictionsDto, 'applications' | 'isApplicationsRestricted'>> & {
  applications?: Partial<RentalManagerUserPropertyDetailsApplicationsRestrictionDto>;
}): Omit<RentalManagerListingRestrictionsDto, 'isApplicationsRestricted' | 'isContactsRestricted'> => ({
  applications: Applications(applications),
  isAnalyticsRestricted: Boolean(isAnalyticsRestricted),
  isCloneListingRestricted: Boolean(isCloneListingRestricted),
  isLeaseBuilderRestricted: Boolean(isLeaseBuilderRestricted),
  isLeasesRestricted: Boolean(isLeasesRestricted),
  isMessagesRestricted: Boolean(isMessagesRestricted),
  isPaymentsRestricted: Boolean(isPaymentsRestricted),
  isPropertyAmenitiesUpdateRestricted: Boolean(isPropertyAmenitiesUpdateRestricted),
  isReviewsRestricted: Boolean(isReviewsRestricted),
  isUpdateAgentRestricted: Boolean(isUpdateAgentRestricted),
  isUpdateListingRestricted: Boolean(isUpdateListingRestricted),
  isUpdateSpecialOffersRestricted: Boolean(isUpdateSpecialOffersRestricted),
  isUpdateUnitNumberRestricted: Boolean(isUpdateUnitNumberRestricted),
  isUpdateUnitRestricted: Boolean(isUpdateUnitRestricted),
});

export default CurrentPropertyRestrictions;
